import { TFunction } from 'i18next'

import { invoiceStatusToTitleKey } from '@features/invoicesLegacy/constants/invoiceStatusToTitleKey'
import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

export const getInvoicesTitle = (status = InvoiceStatus.All, amount: number, t: TFunction): string => {
  const tKey = invoiceStatusToTitleKey[status]

  return t(tKey, { count: amount })
}
